module.exports = __webpack_public_path__ + "img/paytype-top.4b852793.png";